import ModalAccessibility from "../utilities/modalAccessibility";
import selfInstantiateOnLoad from "../utilities/instantiateUtility";
class ProductDetails {
    constructor() {
        const msrpModal = document.getElementById("msrp-modal");
        msrpModal.addEventListener("keydown", (e) => {
            ModalAccessibility.handleModalTabbing(msrpModal, "", e);
        });
    }
}
selfInstantiateOnLoad(ProductDetails);
